import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  background: #fff;
  box-shadow: ${props => props.theme.palette.general.boxShadow};
  position: absolute;
  top: 38px;
  padding: 14px 12px;
  width: 310px;
  z-index: 2;
  ${bp('sm')`
    width: auto;
    left: 10px;
    right: 10px;
    top: 50px;
  `}

  ul {
    list-style: none;
    padding: 0;
    margin-bottom: 0;

    li {
      padding: 12px 20px;

      a,
      span {
        padding: 5px 10px;
        color: ${props => props.theme.palette.general.strong};
        text-decoration: none;
      }

      &.has-icon {
        > a {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  span.back {
    color: ${props => props.theme.palette.primary.alphaDark};
    font-weight: bold;
    cursor: pointer;
  }
`
